import React from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import { Link } from "react-router-dom";
import "./header.css";
import Scrollchor from "react-scrollchor";
import Logo from "../Logo/Logo";

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div>
        <Navbar color="faded" dark expand="md" className="fixed-top">
          <Link to="/" className="align-middle navbar-brand">
            <Logo className="navbar__logo" />
          </Link>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            {
              <Nav className="ml-auto" navbar>
                <NavItem>
                  {this.props.history.location.pathname === "/about-us" ? (
                    <NavLink href="/#work" className="nav-link">
                      Work
                    </NavLink>
                  ) : (
                    <Scrollchor to="#work" className="nav-link">
                      Work
                    </Scrollchor>
                  )}
                </NavItem>
                <NavItem>
                  <Scrollchor to="#contacts" className="nav-link">
                    Contacts
                  </Scrollchor>
                </NavItem>
                <NavItem>
                  <Link to={`/about-us`} className="nav-link">
                    About Us
                  </Link>
                </NavItem>
              </Nav>
            }
          </Collapse>
        </Navbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js